export default function activityTrackerReducer(
    state: any = {
        loading: false,
        done: false,
        response: null,
        error: null,
        success: null,
        updated: null,
    },
    action: any) {

    switch (action.type) {

        /**
         *     Tracker activity reducer
         */
        case 'FETCH_TRACKER_ACTIVITY_TYPES_PENDING': {
            return { ...state, loading: true, success: null }
        }

        case 'FETCH_TRACKER_ACTIVITY_TYPES_REJECTED': {
            return { ...state, loading: false, error: action.payload, success: false }
        }

        case 'FETCH_TRACKER_ACTIVITY_TYPES_FULFILLED': {
            return { ...state, loading: false, done: true, error: null, response: action.payload }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/activityTracker.ts